import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=3cc54901&scoped=true"
import script from "./Paragraph.vue?vue&type=script&lang=ts"
export * from "./Paragraph.vue?vue&type=script&lang=ts"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=3cc54901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc54901",
  null
  
)

export default component.exports